import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${window.location.origin}/api`;
const BestSellerContext = createContext({ bestSellerId: null, bestSellerName: null });

/**
 * Fetches the "Best Seller of the Day" once on mount and exposes it to
 * any ProductCard so they can render a small ribbon. Refreshes every 5 min.
 *
 * Backend endpoint: GET /api/products/best-seller-today
 *   → { product_id, total_qty, name }
 */
export function BestSellerProvider({ children }) {
  const [state, setState] = useState({ bestSellerId: null, bestSellerName: null });

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await axios.get(`${API}/products/best-seller-today`);
        if (!cancelled) {
          setState({
            bestSellerId: r.data?.product_id || null,
            bestSellerName: r.data?.name || null,
          });
        }
      } catch {
        /* silent — ribbon just won't show */
      }
    };
    load();
    const interval = setInterval(load, 5 * 60 * 1000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return (
    <BestSellerContext.Provider value={state}>{children}</BestSellerContext.Provider>
  );
}

export function useBestSeller() {
  return useContext(BestSellerContext);
}
